<template>
  <div>
    
    <b-card class="md-3">
      <b-row>
        <b-col class="align-left">
          <p>Estados de los nodos</p>
        </b-col>
      </b-row>

      <!-- Tabla con la lista de dispositivos-->
      <b-card-text class="deviceStatusTable">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :isLoading.sync="isLoading"
          :search-options="{
          enabled: true,
          //trigger: 'enter',
          skipDiacritics: true,
          //searchFn: mySearchFn,
          placeholder: 'Buscar en la tabla',
          //externalQuery: searchQuery
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'device.uuid', type: 'asc'}
          }"
          :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 10,
              dropdownAllowAll: false,
              //setCurrentPage: 2,
              nextLabel: '',
              prevLabel: '',
              rowsPerPageLabel: 'Filas por pagina',
              ofLabel: 'de',
              pageLabel: 'pagina', // for 'pages' mode
              allLabel: 'Todas',
            }">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'updated'">
                {{getUpdatedFormatted(props.row.updated)}}
              </span>
              <span v-else-if="props.column.field == 'lastUpdated'">
                {{getDateFormatted(props.row.lastUpdated)}}
              </span>
              <span v-else-if="props.column.field == 'lastSent'">
                {{getDateFormatted(props.row.lastSent)}}
              </span>
            </template>
            <template slot="loadingContent">
              <table-loading />
            </template>
            <template slot="emptystate">
              <table-empty-state />
            </template>
        </vue-good-table>

      </b-card-text>

    </b-card>
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import DeviceStatusService from "@/services/DeviceStatusService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "device-status-list",
  data(){
    return {
      alias: "",
      isLoading: false,
      columns: [
        {
          label: 'ID',
          field: 'ssid_status',
          hidden: true
        },
        {
          label: 'Nodo - UUID',
          field: 'device.uuid',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
         {
          label: 'Nodo - Alias',
          field: 'device.alias',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Actualizado',
          field: 'updated',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Último envío',
          field: 'lastSent',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Última actualización',
          field: 'lastUpdated',
          thClass: 'text-center',
          tdClass: 'text-center'
        }
      ],
      rows: [ ]
    };
  },
  components: {
    VueGoodTable,
    'table-loading': TableLoading, 
    'table-empty-state': TableEmptyState
  },
  methods: {
    
    retrieveAllDevicesStatus() {
      this.rows = [];
      this.isLoading = true;
      DeviceStatusService.getAll()
        .then(response => {
          this.rows = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
    },

    getUpdatedFormatted(updated){
      return updated==true ? "Si" : "No"
    }, 

    getDateFormatted(string){
      return this.$moment(String(string)).local().format('DD/MM/YYYY HH:mm:ss')
    }
  },
  mounted() {
    this.retrieveAllDevicesStatus();
  }
}
</script>